import { ActionReducer, INIT } from '@ngrx/store';
import { clearState } from '@store/actions/environment.actions';

export const clearStore = (reducer: ActionReducer<any>): ActionReducer<any> => {
	return (state, action) => {
		if (action && action.type === clearState.type) {
			return reducer(undefined, { type: INIT });
		}

		return reducer(state, action);
	};
};
